<template>
  <div>
    <div class="row q-col-gutter-md q-mb-lg ">
      <model-form-input
        field="config.marketingSignupTitle"
        value-type="String"
        class="col-6"
        label="Title"
      />
      <q-checkbox
        v-model="section.config.marketingSignupHasTitle"
        class="col-6 col-sm-2"
        label="Show Title"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.marketingSignupHasSubtitle"
        class="col-6 col-sm-2"
        label="Show Subtitle"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.marketingSignupHasLightText"
        class="col-6 col-sm-2"
        label="Light Text"
        bottom-slots
      />
    </div>
    <div class="row q-col-gutter-md q-mb-lg ">
      <model-form-input
        v-if="section.config.marketingSignupHasSubtitle"
        field="config.marketingSignupSubtitle"
        value-type="String"
        class="col-6"
        label="Subtitle"
      />
      <q-checkbox
        v-model="section.config.collectName"
        class="col-6 col-sm-2"
        label="Collect Name"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.collectConsent"
        class="col-6 col-sm-2"
        label="Collect Consent"
        bottom-slots
      />
      <q-checkbox
        v-model="section.config.marketingSignupHasImage"
        class="col-6 col-sm-2"
        label="Show Image"
        bottom-slots
      />
    </div>
    <div class="row q-col-gutter-md q-mb-lg ">
      <q-select
        v-model="section.config.marketingSignupDisplayType"
        class="col-3"
        :options="widgetDisplayTypesOptions"
        map-options
        emit-value
        clearable
        label="Signup Form Display Type"
      />
      <q-checkbox
        v-if="section.config.marketingSignupDisplayType === WIDGET_DISPLAY_TYPES.EMBED"
        v-model="section.config.inline"
        class="col-6 col-sm-3"
        label="Inline"
        bottom-slots
      />
      <template v-if="section.config.marketingSignupDisplayType === WIDGET_DISPLAY_TYPES.POPUP">
        <q-select
          v-model="section.config.marketingSignupPopupTriggerType"
          class="col-3"
          :options="popupTriggerOptions"
          map-options
          emit-value
          clearable
          label="Display Popup"
        />
        <q-input
          v-if="section.config.marketingSignupPopupTriggerType === POPUP_TRIGGER_TYPES.LOAD"
          v-model.number="section.config.marketingSignupDisplayDelayInSeconds"
          class="col-6 col-sm-3"
          label="Delay (seconds) "
          type="number"
          min="0"
          max="60"
          step="0.5"
        >
          <q-tooltip>Widget popup delay in second after the page load</q-tooltip>
        </q-input>
        <q-input
          v-if="section.config.marketingSignupPopupTriggerType === POPUP_TRIGGER_TYPES.SCROLL"
          v-model.number="section.config.marketingSignupDisplayScrollPercentage"
          class="col-6 col-sm-3"
          label="Scroll percentage"
          type="number"
          min="0"
          max="100"
          step="10"
        >
          <q-tooltip>Widget popup when scroll to certain percentage of the page</q-tooltip>
        </q-input>
        <q-select
          v-model="section.config.marketingSignupPopupFrequencyType"
          class="col-3"
          :options="popupFrequencyOptions"
          map-options
          emit-value
          clearable
          label="Widget Popup Frequency"
        />
      </template>
    </div>
    <form-control-style-editor
      :field-type="section.config.marketingSignupTextFieldType"
      :field-outlined="section.config.marketingSignupHasTextFieldOutline"
      is-text-field
      class="row q-col-gutter-md q-mb-md"
      @update:model-value="setTextFieldStyle"
    />

    <button-style-editor
      class="row q-col-gutter-md q-mb-md items-start"
      button-type-label="Button Type"
      color-label="Button Color"
      border-radius-label="Border Radius"
      :button-type="section.config.marketingSignupButtonType"
      :color-name="section.config.marketingSignupButtonColor"
      :custom-color-hex="section.config.marketingSignupButtonColorHex"
      :button-border-radius="section.config.marketingSignupButtonBorderRadius"
      @update:model-value="setButtonStyle"
    />

    <div
      v-if="section.config.marketingSignupHasImage"
      class="row q-col-gutter-md q-mb-md items-start"
    >
      <q-select
        v-model="section.config.marketingSignupImagePositionType"
        class="col-6 col-sm-3"
        label="Image Position"
        :options="imagePositionTypeOptions"
        map-options
        emit-value
      />
      <div class="col-3 column q-col-gutter-sm">
        <image-uploader
          v-model="section.config.marketingSignupImage"
          class="col"
          min-height="150px"
          :image-url="section.marketingSignupImageUrl"
          :model="section"
        />
      </div>
    </div>
    <preview
      :section="section"
      class="q-mb-xl"
    />
  </div>
</template>

<script>
import Section, { IMAGE_POSITION_TYPES, POPUP_FREQUENCY_TYPES, POPUP_TRIGGER_TYPES, WIDGET_DISPLAY_TYPES } from 'src/models/page/Section'
import ButtonStyleEditor from 'src/modules/admin/components/ButtonStyleEditor'
import FormControlStyleEditor from 'src/modules/admin/components/FormControlStyleEditor'
import ImageUploader from 'src/modules/admin/components/ImageUploader'
import Preview from 'src/modules/consumer/components/Preview'

export default {
  name: 'MarketingSignupEditor',
  components: {
    ImageUploader,
    Preview,
    ButtonStyleEditor,
    FormControlStyleEditor
  },
  props: {
    section: {
      type: Section,
      required: true
    }
  },
  created () {
    _.extend(this, {
      popupTriggerOptions: this.$mh.asOptions(POPUP_TRIGGER_TYPES),
      popupFrequencyOptions: this.$mh.asOptions(POPUP_FREQUENCY_TYPES),
      widgetDisplayTypesOptions: this.$mh.asOptions(WIDGET_DISPLAY_TYPES),
      imagePositionTypeOptions: this.$mh.asOptions(IMAGE_POSITION_TYPES),
      WIDGET_DISPLAY_TYPES,
      POPUP_TRIGGER_TYPES,
      POPUP_FREQUENCY_TYPES,
      IMAGE_POSITION_TYPES
    })
  },
  methods: {
    setButtonStyle (buttonType, colorName, customColorHex, buttonRadius) {
      this.section.config.marketingSignupButtonType = buttonType
      this.section.config.marketingSignupButtonColor = colorName
      this.section.config.marketingSignupButtonColorHex = customColorHex
      this.section.config.marketingSignupButtonBorderRadius = buttonRadius
    },
    setTextFieldStyle (fieldType, fieldOutlined) {
      this.section.config.marketingSignupTextFieldType = fieldType
      this.section.config.marketingSignupHasTextFieldOutline = fieldOutlined
    }
  }
}

</script>

<style scoped>
</style>
